import { Popover } from "antd"
import { Trash } from "lucide-react"
import { ReactNode } from "react"
import BaseButton from "../../../components/elements/BaseButton"

type TourDeletePopoverType = {
    title?: string
    text: string
    onConfirm: () => void
    children?: ReactNode
    iconClassName?: string
    trigger?: "hover" | "click"
}

export default function TourDeletePopover(props: TourDeletePopoverType) {
    return (
        <Popover
            trigger={props.trigger ?? "hover"}
            placement="bottomLeft"
            title={props.title ?? "Löschen?"}
            content={
                <div className="flex flex-col items-end">
                    <p>{props.text}</p>
                    <BaseButton
                        label="Löschen"
                        func={props.onConfirm}
                        colorway="warning"
                        size="small"
                        classProps="mt-2"
                    />
                </div>
            }>
            {props.children ?? <Trash className={props.iconClassName ?? "w-6 h-6 cursor-pointer hover:text-error"} />}
        </Popover>
    )
}
